<template>
  <el-table-column
    prop="own_company.name"
    label="Saját cég"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.own_company.name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'own_company.name',
  };
</script>
